const text = `
## NPC
## ENN
## INSTEA
## Holland chamber of Commerce in Slovak Republic - Adriana Kukučková
## Slovak - Austrian chamber of Commerce - Katarína Žilinská
## American chamber of Commerce - Veronika Yorumez
## Embassy of Indonesia - Oliver Kovalský
## Embassy of Ukraine - Savenko Bohdan
## British chamber of commerce - Hajnalka Hayler
`
const sponsors = []

export default {
  text,
  sponsors,
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/sponsors/partners.js